{
  "students": {
    "studentsList": [
      {
        "accountId": "2313456075",
        "identityId": "2313456075",
        "firstName": "Mikael",
        "lastName": "Iuturna",
        "nickName": "Mike",
        "gradeId": "0",
        "schoolId": "digital-academy-of-texas",
        "schoolName": "Digital Academy of Texas",
        "schoolShortName": "DAT",
        "entryDate": null,
        "age": 4,
        "hasFlexProgram": false,
        "roleId": 1001
      }
    ]
  }
}
